module.exports = __webpack_public_path__ + "img/705d147.png";